import { BaseResponse } from '../../models/comm-http/responses/BaseResponse';
import { ssApiService } from '../../services/ss-api.service';
import { Component, OnInit } from '@angular/core';

import Swal, { SweetAlertIcon } from 'sweetalert2';
import { xToastr, ToastrTypes } from 'app/shared/Toastr';
import { DashboardLicenseResponse } from 'app/models/ss-api/responses/dashboard.license.response';
import { CancelYardRequest } from 'app/models/ss-api/requests/cancel.yard.request';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import {DynamicDialogConfig} from 'primeng/dynamicdialog';

export interface IConfirmDialogModel {
  title: string;
  subTitle: string;
  message: string;
  License: DashboardLicenseResponse;
}

@Component({
  selector: 'yard-cancellation-request-dialog',
  styleUrls: ['./yard-cancellation-request-dialog.component.scss'],
  templateUrl: './yard-cancellation-request-dialog.component.html'
})
export class YARDCancellationRequestDialogComponent implements IConfirmDialogModel, OnInit {


  confirmTitle: string = 'Cancel YARD';
  confirmMessage: string = 'You are about to cancel this YARD membership.';

  successTitle: string = 'Cancellation successfull';
  successMessage: string = 'Your YARD membership is cancelled.';

  errorTitle: string = 'Error';
  errorMessage: string = 'We were not able to cancel YARD. Please contact support.';

  cancelledTitle: string = 'Cancelled Request';
  cancelledMessage: string = 'You cancelled the request.';


  title: string;
  subTitle: string;
  message: string;
  License: DashboardLicenseResponse;
  CancellationReason: string;

  step: number = 1;

  result: any;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private api: ssApiService
  ) {
  }

  ngOnInit() {
    this.title = this.config.data.title;
    this.subTitle = this.config.data.subTitle;
    this.message = this.config.data.message;
    this.License = this.config.data.License;
  }

  close() {
      this.ref.close();
  }

  private CancelProduct(): Promise<any> {

    // if (this.SelectedCreditCard == undefined)
    // we didn't change the credit card selection
    // this.SelectedCreditCard = this.CreditCards[0];

    let request = new CancelYardRequest();
    request.LicenseKey = this.License.Key;
    request.CancelReason = this.CancellationReason;


    return this.api.YardCancel( request )
      .toPromise()
      .then(response => {

        if (!response.Result)
          return; // error

        this.result = response.Result;
        return response;
      });
  }

  ProcessCancellation(): Promise<any> {
    // confirm
    return Swal.fire({
      title: this.confirmTitle,
      text: this.confirmMessage,
      icon: 'warning',
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: 'Yes, cancel!',
      cancelButtonText: 'No, keep',
      allowOutsideClick: false,
      showLoaderOnConfirm: true,
      preConfirm: () => {
        // try to order
        return this.CancelProduct();
      }
    });

  }

  async confirm() {

    if ( this.CancellationReason == '' || this.CancellationReason == undefined) {
      xToastr.ShowToast(ToastrTypes.Error, 'Error', 'Please enter \'Reason For Canceling\'');
      return;
    }

    await this.ProcessCancellation().then(
      (response: any) => {

        // init dialog vars
        let cType = 'success';
        let cTitle = this.successTitle;
        let cMessage = this.successMessage;

        if (response.isDismissed) {
          cType = 'error';
          cTitle = this.cancelledTitle;
          cMessage = this.cancelledMessage;
        } else if (!response.value || !response.value.Result) {
          // not ok
          cType = 'error';
          cTitle = this.errorTitle;
          cMessage = this.errorMessage;
        }

        // show result
        Swal.fire(
          {
            title: cTitle,
            text: cMessage,
            icon: cType as SweetAlertIcon,
            showCancelButton: false,
            showConfirmButton: false,
            timer: 1500
          })
          .then(() => { }, () => { }); // keep this line to prevent promise error;

      },
      (dismiss) => {
        if (dismiss === 'cancel') {

          if (!confirm)
            return;

          // show cancelled
          Swal.fire({
            title: this.cancelledTitle,
            text: this.cancelledMessage,
            icon: 'error',
            showCancelButton: false,
            showConfirmButton: false,
            timer: 1000
          })
            .then(() => { }, () => { }); // keep this line to prevent promise error;
        }
      });

    this.result = true;
    this.close();
  }


  cancel() {
    this.result = false;
    this.close();
  }

  nextStep() {
    this.step++;
  }

  onContactUs() {
    window.open('https://www.structurestudios.com/help/kb-tickets/new', '_blank');
  }
}
